import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import { Sparkles } from "lucide-react";

export const Markdown = ({ children, testId }) => (
  <div className="prose-lindsay text-[15px]" data-testid={testId}>
    <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]} components={{ table: ({ node, ...p }) => <div className="prose-table-wrap"><table {...p} /></div> }}>{children || ""}</ReactMarkdown>
  </div>
);

export const AIBadge = () => (
  <span className="ai-pulse inline-flex items-center gap-1.5 rounded-full border border-pinkb/40 bg-pinkb/10 px-3 py-1 text-[11px] font-mono text-pinkb" data-testid="ai-assisted-badge">
    <Sparkles className="h-3 w-3" /> AI-assisted · built on Lindsay's knowledge bank
  </span>
);

const STATUS = {
  pending: ["Thinking", "bg-white text-muted-foreground border-border"],
  in_review: ["Lindsay reviewing", "bg-sky-50 text-sky-700 border-sky-200"],
  answered: ["Answered", "bg-emerald-50 text-emerald-700 border-emerald-600/30"],
  reviewed: ["Reviewed", "bg-emerald-50 text-emerald-700 border-emerald-600/30"],
  escalated: ["With Lindsay", "bg-rose-50 text-rose-600 border-rose-200"],
  lindsay_answered: ["Lindsay replied", "bg-pinkb/10 text-pinkb border-pinkb/40"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || [status, "border-border"];
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-mono uppercase tracking-wider ${cls}`}>
      {label}
    </span>
  );
};

export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="mb-10 fade-up flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
    <div>
      <div className="eyebrow mb-3">{eyebrow}</div>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">{title}</h1>
    </div>
    {children}
  </div>
);

export const LindsayReply = ({ text }) => (
  <div className="mt-5 rounded-xl border border-pinkb/40 bg-pinkb/5 p-5" data-testid="lindsay-personal-reply">
    <div className="eyebrow mb-2">Personal reply from Lindsay</div>
    <Markdown>{text}</Markdown>
  </div>
);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");
